module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABOklEQVQ4jXWS0U3DYAyEj4oB8sZrmYCyQZmg6QZlgzIBMAHtBMAEpRPABuSJV7oBGQAJ9IWzZKzGUlXHPt9vn33yffahYitJC0ltib9I2kt6ysFM0EjaSZqnAmJTSV0ifJO0lNTzMUnFny4mcWPQ3sX4V8bOjW0ywc6Ba//CNi6WO7l3PrrVqWeG9eDXuiqKLWafGUvNamLBes/WptdmI0StsdQsEPHHgi0L6FHSeYh1xBihzSKuy8oY5WGkeF1FPGZb6/Mq6W4MFAQHK55tah+xbsthbVwzEMSRNIXgYoQwRqamm7jVqgH2nPzeulQNtnHK714bm8hAXo1Tjm3wMhsgdhkacF0ASGTBmDN2jpEDw/dwsUEAG7fOP4J9+Q7oig7wiZHL2H9rHFoyMy/HiUOCT4wcmL9zl/QLNJNVNksVoAIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_icon_water_pressure.png
// module id = E5TF
// module chunks = 4